/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateProductCategoryPostRequest as BackendCoreApiModelsAppCreateProductCategoryPostRequest } from '../models/Backend/Core/Api/Models/App/create-product-category-post-request';
import { CreateProductPostRequest as BackendCoreApiModelsAppCreateProductPostRequest } from '../models/Backend/Core/Api/Models/App/create-product-post-request';
import { PinPostRequest as BackendCoreApiModelsAppPinPostRequest } from '../models/Backend/Core/Api/Models/App/pin-post-request';
import { GetProductCategoryResponse as BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse } from '../models/Backend/Core/Api/Models/App/Product/Category/get-product-category-response';
import { ProductCategoryCollectionResponse as BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse } from '../models/Backend/Core/Api/Models/App/Product/Category/product-category-collection-response';
import { ProductCategoryRequest as BackendCoreApiModelsAppProductCategoryProductCategoryRequest } from '../models/Backend/Core/Api/Models/App/Product/Category/product-category-request';
import { CollectionBaseRequest as BackendCoreApiModelsAppProductCollectionBaseRequest } from '../models/Backend/Core/Api/Models/App/Product/collection-base-request';
import { CollectionByProductCategoryRequest as BackendCoreApiModelsAppProductCollectionByProductCategoryRequest } from '../models/Backend/Core/Api/Models/App/Product/collection-by-product-category-request';
import { ChangeProductStateRequest as BackendCoreApiModelsAppProductOrderChangeProductStateRequest } from '../models/Backend/Core/Api/Models/App/Product/Order/change-product-state-request';
import { CreateProductOrderRequest as BackendCoreApiModelsAppProductOrderCreateProductOrderRequest } from '../models/Backend/Core/Api/Models/App/Product/Order/create-product-order-request';
import { ProductOrderCollectionResponse as BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse } from '../models/Backend/Core/Api/Models/App/Product/Order/product-order-collection-response';
import { PostCollectionResponse as BackendCoreApiModelsAppProductPostPostCollectionResponse } from '../models/Backend/Core/Api/Models/App/Product/Post/post-collection-response';
import { ProductCollectionResponse as BackendCoreApiModelsAppProductProductCollectionResponse } from '../models/Backend/Core/Api/Models/App/Product/product-collection-response';
import { ProductSelectorCollectionResponse as BackendCoreApiModelsAppProductProductSelectorCollectionResponse } from '../models/Backend/Core/Api/Models/App/Product/product-selector-collection-response';
import { RemovePostRequest as BackendCoreApiModelsAppRemovePostRequest } from '../models/Backend/Core/Api/Models/App/remove-post-request';
import { UpdateProductCategoryPostRequest as BackendCoreApiModelsAppUpdateProductCategoryPostRequest } from '../models/Backend/Core/Api/Models/App/update-product-category-post-request';
import { UpdateProductPostRequest as BackendCoreApiModelsAppUpdateProductPostRequest } from '../models/Backend/Core/Api/Models/App/update-product-post-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class ProductBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createProductOrder
   */
  static readonly CreateProductOrderPath = '/api/product-order/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductOrder$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductOrder$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductOrderCreateProductOrderRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.CreateProductOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductOrder$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductOrder$Plain(params?: {
    body?: BackendCoreApiModelsAppProductOrderCreateProductOrderRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductOrder$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductOrder$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductOrder$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductOrderCreateProductOrderRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.CreateProductOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductOrder$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductOrder$Json(params?: {
    body?: BackendCoreApiModelsAppProductOrderCreateProductOrderRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductOrder$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation createProductPost
   */
  static readonly CreateProductPostPath = '/api/product/create-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppCreateProductPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.CreateProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductPost$Plain(params?: {
    body?: BackendCoreApiModelsAppCreateProductPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppCreateProductPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.CreateProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductPost$Json(params?: {
    body?: BackendCoreApiModelsAppCreateProductPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation createProductCategoryPost
   */
  static readonly CreateProductCategoryPostPath = '/api/product-categories/create-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductCategoryPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppCreateProductCategoryPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.CreateProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductCategoryPost$Plain(params?: {
    body?: BackendCoreApiModelsAppCreateProductCategoryPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductCategoryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProductCategoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductCategoryPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppCreateProductCategoryPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.CreateProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createProductCategoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createProductCategoryPost$Json(params?: {
    body?: BackendCoreApiModelsAppCreateProductCategoryPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createProductCategoryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation removeProductPost
   */
  static readonly RemoveProductPostPath = '/api/product/remove-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.RemoveProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeProductPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductPost$Plain(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeProductPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.RemoveProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeProductPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductPost$Json(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeProductPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation setProductState
   */
  static readonly SetProductStatePath = '/api/product/set-product-state';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setProductState$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setProductState$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductOrderChangeProductStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.SetProductStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setProductState$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setProductState$Plain(params?: {
    body?: BackendCoreApiModelsAppProductOrderChangeProductStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.setProductState$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `setProductState$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setProductState$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductOrderChangeProductStateRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.SetProductStatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `setProductState$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  setProductState$Json(params?: {
    body?: BackendCoreApiModelsAppProductOrderChangeProductStateRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.setProductState$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation removeProductCategoryPost
   */
  static readonly RemoveProductCategoryPostPath = '/api/product-categories/remove-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductCategoryPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.RemoveProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeProductCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductCategoryPost$Plain(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeProductCategoryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeProductCategoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductCategoryPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.RemoveProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeProductCategoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeProductCategoryPost$Json(params?: {
    body?: BackendCoreApiModelsAppRemovePostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeProductCategoryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getProductCategory
   */
  static readonly GetProductCategoryPath = '/api/product-category';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategory$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategory$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategory$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategory$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse> {

    return this.getProductCategory$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>) => r.body as BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategory$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategory$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoryPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategory$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategory$Json(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse> {

    return this.getProductCategory$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse>) => r.body as BackendCoreApiModelsAppProductCategoryGetProductCategoryResponse)
    );
  }

  /**
   * Path part for operation getProductPosts
   */
  static readonly GetProductPostsPath = '/api/product/posts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductPosts$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductPosts$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionBaseRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductPostsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductPosts$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductPosts$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionBaseRequest
  }): Observable<BackendCoreApiModelsAppProductPostPostCollectionResponse> {

    return this.getProductPosts$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppProductPostPostCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductPosts$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductPosts$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionBaseRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductPostsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductPosts$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductPosts$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionBaseRequest
  }): Observable<BackendCoreApiModelsAppProductPostPostCollectionResponse> {

    return this.getProductPosts$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppProductPostPostCollectionResponse)
    );
  }

  /**
   * Path part for operation getProducts
   */
  static readonly GetProductsPath = '/api/product-categories/products';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProducts$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducts$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProducts$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductProductCollectionResponse> {

    return this.getProducts$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>) => r.body as BackendCoreApiModelsAppProductProductCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProducts$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducts$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProducts$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductProductCollectionResponse> {

    return this.getProducts$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>) => r.body as BackendCoreApiModelsAppProductProductCollectionResponse)
    );
  }

  /**
   * Path part for operation getProductCategoryPosts
   */
  static readonly GetProductCategoryPostsPath = '/api/product-categories/posts';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategoryPosts$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPosts$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoryPostsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategoryPosts$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPosts$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductPostPostCollectionResponse> {

    return this.getProductCategoryPosts$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppProductPostPostCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategoryPosts$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPosts$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoryPostsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategoryPosts$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPosts$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductPostPostCollectionResponse> {

    return this.getProductCategoryPosts$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppProductPostPostCollectionResponse)
    );
  }

  /**
   * Path part for operation getProductOrders
   */
  static readonly GetProductOrdersPath = '/api/product-categories/orders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductOrders$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductOrders$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductOrdersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductOrders$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductOrders$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse> {

    return this.getProductOrders$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse>) => r.body as BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductOrders$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductOrders$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductOrdersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductOrders$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductOrders$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse> {

    return this.getProductOrders$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse>) => r.body as BackendCoreApiModelsAppProductOrderProductOrderCollectionResponse)
    );
  }

  /**
   * Path part for operation getProductCategories
   */
  static readonly GetProductCategoriesPath = '/api/product-categories';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategories$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategories$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoriesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategories$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategories$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse> {

    return this.getProductCategories$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse>) => r.body as BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategories$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategories$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoriesPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategories$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategories$Json(params?: {
    body?: BackendCoreApiModelsAppProductCategoryProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse> {

    return this.getProductCategories$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse>) => r.body as BackendCoreApiModelsAppProductCategoryProductCategoryCollectionResponse)
    );
  }

  /**
   * Path part for operation getProductsForAdministration
   */
  static readonly GetProductsForAdministrationPath = '/api/product-categories/products-admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductsForAdministration$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductsForAdministration$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductsForAdministrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductsForAdministration$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductsForAdministration$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductProductCollectionResponse> {

    return this.getProductsForAdministration$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>) => r.body as BackendCoreApiModelsAppProductProductCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductsForAdministration$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductsForAdministration$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductsForAdministrationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductsForAdministration$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductsForAdministration$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductProductCollectionResponse> {

    return this.getProductsForAdministration$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductProductCollectionResponse>) => r.body as BackendCoreApiModelsAppProductProductCollectionResponse)
    );
  }

  /**
   * Path part for operation getProductCategoryPostsAdmin
   */
  static readonly GetProductCategoryPostsAdminPath = '/api/product-categories/posts-admin';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategoryPostsAdmin$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPostsAdmin$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoryPostsAdminPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategoryPostsAdmin$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPostsAdmin$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductPostPostCollectionResponse> {

    return this.getProductCategoryPostsAdmin$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppProductPostPostCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductCategoryPostsAdmin$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPostsAdmin$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductCategoryPostsAdminPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductCategoryPostsAdmin$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductCategoryPostsAdmin$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductPostPostCollectionResponse> {

    return this.getProductCategoryPostsAdmin$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppProductPostPostCollectionResponse)
    );
  }

  /**
   * Path part for operation getProductSelectors
   */
  static readonly GetProductSelectorsPath = '/api/product-categories/product-selectors';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSelectors$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductSelectors$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductProductSelectorCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductSelectorsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductProductSelectorCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductSelectors$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductSelectors$Plain(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductProductSelectorCollectionResponse> {

    return this.getProductSelectors$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductProductSelectorCollectionResponse>) => r.body as BackendCoreApiModelsAppProductProductSelectorCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSelectors$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductSelectors$Json$Response(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppProductProductSelectorCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.GetProductSelectorsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppProductProductSelectorCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProductSelectors$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getProductSelectors$Json(params?: {
    body?: BackendCoreApiModelsAppProductCollectionByProductCategoryRequest
  }): Observable<BackendCoreApiModelsAppProductProductSelectorCollectionResponse> {

    return this.getProductSelectors$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppProductProductSelectorCollectionResponse>) => r.body as BackendCoreApiModelsAppProductProductSelectorCollectionResponse)
    );
  }

  /**
   * Path part for operation pinProductCategoryPost
   */
  static readonly PinProductCategoryPostPath = '/api/product-categories/pin-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pinProductCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductCategoryPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.PinProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pinProductCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductCategoryPost$Plain(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.pinProductCategoryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pinProductCategoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductCategoryPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.PinProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pinProductCategoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductCategoryPost$Json(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.pinProductCategoryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation pinProductPost
   */
  static readonly PinProductPostPath = '/api/product/pin-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pinProductPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.PinProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pinProductPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductPost$Plain(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.pinProductPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pinProductPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.PinProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pinProductPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinProductPost$Json(params?: {
    body?: BackendCoreApiModelsAppPinPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.pinProductPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation updateProductPost
   */
  static readonly UpdateProductPostPath = '/api/product/update-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppUpdateProductPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.UpdateProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProductPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductPost$Plain(params?: {
    body?: BackendCoreApiModelsAppUpdateProductPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateProductPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppUpdateProductPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.UpdateProductPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProductPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductPost$Json(params?: {
    body?: BackendCoreApiModelsAppUpdateProductPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateProductPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation updateProductCategoryPost
   */
  static readonly UpdateProductCategoryPostPath = '/api/product-categories/update-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductCategoryPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductCategoryPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppUpdateProductCategoryPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.UpdateProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProductCategoryPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductCategoryPost$Plain(params?: {
    body?: BackendCoreApiModelsAppUpdateProductCategoryPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateProductCategoryPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductCategoryPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductCategoryPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppUpdateProductCategoryPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, ProductBackendService.UpdateProductCategoryPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateProductCategoryPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateProductCategoryPost$Json(params?: {
    body?: BackendCoreApiModelsAppUpdateProductCategoryPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateProductCategoryPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
